import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedReorder202512: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_reorder_202512",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-12-01",
  endDate: "2025-12-31",
  impressions: 8474,
  clicks: 162,
  adsSpendDollars: 593,
  budgetDollars: 900,
  salesDollars: 4041,
  bestEstimateRoas: 6.81,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.66,
  reorderConversions: 16,
  dataAvailableAtDate: "2026-01-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
